import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";

// MutableRefObject<HTMLDivElement | undefined>
export interface LanguageState {
  clientCountryCode: string;
}

export const initialState: LanguageState = {
  clientCountryCode: "en",
};

const master = createSlice({
  name: "language",
  initialState,
  reducers: {
    setClientCountryCode(state: LanguageState, action: PayloadAction<string>) {
      localStorage.setItem("i18nLng", action.payload);
      state.clientCountryCode = action.payload;
    },
  },
});

export const selectClientCountryCode = (state: ApplicationRootState) =>
  state.language.clientCountryCode;

export const { setClientCountryCode } = master.actions;

export default master.reducer;
